import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { convertEpochToDateString } from '@functions/functions';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { LevelAsset } from '@services/assets-data.service';
import { Rule, RulesDataService } from '@services/rules-data.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import e from 'express';
import { Subject, takeUntil, distinctUntilChanged, filter, finalize } from 'rxjs';

@Component({
	selector: 'app-dashboard-rules',
	templateUrl: './dashboard-rules.component.html',
	styleUrls: ['./dashboard-rules.component.scss']
})
export class DashboardRulesComponent implements OnInit {

	/** accountGUID */
	@Input() accountGUID: string;

	/** organisationUID */
	@Input() organisationUID: string;

	/** panelData */
	@Input() panelData: any;

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** assets */
	public assets: LevelAsset[] = [];

	/** rules */
	public rules: Rule[] = [];

	/** filteredRules */
	public filteredRules: Rule[] = [];

	/** displayedColumns */
	displayedColumns: string[] = ['RuleDescription', 'condition', 'AssetName', 'LastTriggered', 'EventsInPast30Days'];

	/** datasource */
	dataSource: MatTableDataSource<Rule>;

	/** sort */
	@ViewChild(MatSort) sort: MatSort;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		public rulesDataService: RulesDataService,
		public router: Router,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		if (this.panelData) {
			this.assets = this.panelData.assets;
		}
		this.getRules();
	}

	/**
	 * getRules
	 */
	getRules() {
		if (this.panelData) {
			// Create a local Subject to control the subscription lifecycle
			const fetchDataSubject = new Subject<void>();

			this.rulesDataService.getRules$(this.accountGUID, this.organisationUID).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (rules) => {
					const assetIDs: number[] = this.assets.map((x: LevelAsset) => x.AssetID);
					if (assetIDs.length > 0) {
						this.rules = rules.filter((x: Rule) => assetIDs.includes(x.AssetID));
					} else {
						this.rules = rules;
					}
					this.filteredRules = this.rules;
					this.dataSource = new MatTableDataSource(this.filteredRules);
					this.dataSource.sort = this.sort;
				},
				error: (error) => {
					if (error.status != 404) {
						this.globalFunctions.HandleError(error, "Error: this.rulesDataService.getRules$", false);
					}
				}
			});
		} else {
			const newRule: Rule = {
				AssetID: 0,
				RuleDescription: "Example Rule",
				RuleText: "",
				RuleEnabled: true,
				CMMSEnabled: false,
				TriggerTime: 0,
				Active: false,
				CreatedAt: new Date().getTime(),
				ReadableRule: "°C > 10 for 30 Mins",
				CreatedByUserID: 0,
				AssetName: "Example Asset",
				RuleMessage: "",
				RuleDef: [],
				RuleID: 0,
				RuleSubscribers: [],
				EventsInPast30Days: 0,
				LastTriggered: 0,
				SeriesColor: ""
			};
			this.rules = [
				newRule,
				newRule,
				newRule,
				newRule,
				newRule,
				newRule
			];
			this.filteredRules = this.rules;
			this.dataSource = new MatTableDataSource(this.filteredRules);
			this.dataSource.sort = this.sort;
		}
	}

	/** GoToRule */
	GoToRule(rule: Rule) {
		if (this.panelData) this.router.navigate([`./${this.accountGUID}/organisation/${this.organisationUID}/rules/${rule.RuleID}`]);
	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	}
}
